// Ticked events on one side of the brief (ticket 072): a plain bullet list of labels. The box header
// says what the list means (income not entered, or uncommon events).
import React from 'react'

export function EventLines({ events }) {
  if (!events || events.length === 0) return null
  return (
    <ul className="brief-fact-list brief-event-list">
      {events.map(({ key, label }) => <li key={key}>{label}</li>)}
    </ul>
  )
}
